import AlertDialog from '@alltrails/denali/components/AlertDialog';
import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';
import isAndroid from '@alltrails/core/utils/isAndroid';
import isIos from '@alltrails/core/utils/isIos';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import getHelpCenterUrl from '@alltrails/shared/utils/constants/helpCenterUrl';
import useDeeplink from '@alltrails/install-prompt/hooks/useDeeplink';
import styles from './HeadToTheAppDialog.module.scss';

type Props = {
  href?: string;
  onCloseRequest: () => void;
  provider: 'apple' | 'google';
  text: ReactNode; // Maybe later or Get back to exploring
};

const alignedBody: Record<Props['provider'], ReactNode> = {
  apple: <FormattedMessage defaultMessage="Since you’re subscribed with Apple, you’ll need to upgrade there" />,
  google: <FormattedMessage defaultMessage="Since you’re subscribed with Google, you’ll need to upgrade there" />
};

const notAlignedBody: Record<Props['provider'], ReactNode> = {
  apple: <FormattedMessage defaultMessage="Since your subscription is still through Apple, you have a few options" />,
  google: <FormattedMessage defaultMessage="Since your subscription is still through Google, you have a few options" />
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=10314-22342&m=dev
export default function HeadToTheAppMobileDialog({ href, onCloseRequest, provider, text }: Props) {
  const languageRegionCode = useLanguageRegionCode();
  const getDeeplink = useDeeplink({ deeplinkData: { pageId: 'pro', pageType: 'screen' } });

  const aligned = (provider === 'apple' && isIos()) || (provider === 'google' && isAndroid());

  if (aligned) {
    return (
      <AlertDialog
        body={alignedBody[provider]}
        buttons={{
          primary: {
            linkInfo: {
              href: getDeeplink()
            },
            text: <FormattedMessage defaultMessage="Continue in app" />,
            testId: 'contact-support'
          },
          flat: {
            ...(href && { linkInfo: { href } }),
            onClick: () => {
              onCloseRequest();
            },
            text,
            testId: 'maybe-later'
          }
        }}
        onRequestClose={onCloseRequest}
        overlayClassName={styles.overlay}
        title={<FormattedMessage defaultMessage="Head to the app" />}
      />
    );
  }

  return (
    <AlertDialog
      body={notAlignedBody[provider]}
      buttons={{
        primary: {
          linkInfo: {
            href: getHelpCenterUrl(languageRegionCode, 37204002259220),
            target: '_blank'
          },
          text: <FormattedMessage defaultMessage="How to upgrade" />,
          testId: 'how-to-upgrade'
        },
        flat: {
          ...(href && { linkInfo: { href } }),
          onClick: () => {
            onCloseRequest();
          },
          text,
          testId: 'maybe-later'
        }
      }}
      onRequestClose={onCloseRequest}
      overlayClassName={styles.overlay}
      title={<FormattedMessage defaultMessage="New phone? Nice." />}
    />
  );
}
